import React, { useCallback } from 'react';
import { StyledIcon as PlayerIcon } from '../../../Icons';
import { Button } from '../../../Button/styled';
import { handleMute } from '../../../PlayerUIContainer';
const volumeIconsMap = {
    default: {
        mute: 'onDark-control_volume_off',
        low: 'onDark-control_volume_mute',
        medium: 'onDark-control_volume_down',
        high: 'onDark-control_volume_up',
    },
    podcast: {
        mute: 'onPrimary-control_volumeMute',
        low: 'onPrimary-control_volumeLow',
        medium: 'onPrimary-control_volumeMid',
        high: 'onPrimary-control_volumeHigh',
    },
};
const RenderDefaultIcon = (volume, muted, disabled, backgroundColor, styles, variant) => {
    const getIcon = () => {
        const iconVariant = variant === 'podcast' ? 'podcast' : 'default';
        const relevantIcons = volumeIconsMap[iconVariant];
        if (muted) {
            return relevantIcons.mute;
        }
        if (volume < 1 / 3) {
            return relevantIcons.low;
        }
        if (volume < 2 / 3) {
            return relevantIcons.medium;
        }
        return relevantIcons.high;
    };
    return (React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.icon), { opacity: disabled ? 0.4 : 1 }), name: getIcon(), "data-test": "VolumeButton-Icon", className: "VolumeButton-Icon", backgroundColor }));
};
export const VolumeButton = ({ playerInstance, backgroundColor = 'transparent', className = '', show, hide, muted, volume, customIcon = RenderDefaultIcon, disabled, styles = {
    button: null,
    icon: null,
}, variant, }) => {
    const onClick = useCallback((event) => {
        if (disabled)
            return;
        handleMute(playerInstance);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [playerInstance]);
    return (React.createElement(Button, { backgroundColor, disabled, onClick, style: styles.button, "data-test": "VolumeButton", testID: "volume_button", className: `VolumeButton ${className}`, onMouseEnter: show, onPress: show, onMouseLeave: hide, onBlur: hide }, customIcon(volume, muted, disabled, backgroundColor, styles, variant)));
};
//# sourceMappingURL=index.js.map